import { withChartLayout } from 'components/common';
import SavedDrainsTubes from 'components/features/chart/drains-tubes/saved-drains-tubes/SavedDrainsTubes';

const SavedDrainsTubesPage = withChartLayout('Saved Drains - Tubes Charting')(SavedDrainsTubes);
export default SavedDrainsTubesPage;
